import { Typography } from '@mui/material';

interface FieldErrorProps {
  /** Error message; renders nothing when falsy. */
  error?: string | false | null;
}

/**
 * Absolutely-positioned validation message used beneath the auth/profile
 * inputs. Shared by CustomInput and CustomTelInput so the layout stays in sync.
 */
export const FieldError: React.FC<FieldErrorProps> = ({ error }) =>
  error ? (
    <Typography
      sx={{ position: 'absolute', top: '115%', left: '20px' }}
      variant="body2"
      color="error"
    >
      {error}
    </Typography>
  ) : null;
